import CustomButton from "components/Atoms/CustomButton"
import Divider from "components/Atoms/Divider"
import React from "react"
import classNames from "utils/classNames"
import styles from "./style.module.scss"
type FormLayoutProps = {
  children?: React.ReactNode
  title?: React.ReactNode
  subtitle?: React.ReactNode
  header?: React.ReactNode
  onAdd?: () => void
  addBtnText?: string
  className?: string
  rightElement?: React.ReactNode
  padding?: string
}
const FormLayout = ({
  title,
  children,
  addBtnText,
  className,
  subtitle,
  rightElement,
  onAdd,
  padding = "p-3",
  header,
}: FormLayoutProps) => {
  return (
    <div>
      <div className={styles.topBar}>
        <div>
          <h6 className={styles["title"]}>{title}</h6>
          {subtitle && <p className={styles["subtitle"]}>{subtitle}</p>}
        </div>
        {header}
        {rightElement ||
          (onAdd && (
            <CustomButton
              text={addBtnText || title.toString()}
              onClick={onAdd}
              dark
              icon="plus"
            />
          ))}
      </div>
      <Divider className="my-0" />
      <div className={classNames(padding, className)}>{children}</div>
    </div>
  )
}

export default FormLayout
